// Authentic MCC hostel photography supplied by the school.
// `cover` is shown on the Boarding page card; `photos` fill the residence gallery.
export type ResidenceKey = "girls" | "boys";

export type ResidencePhoto = { src: string; alt: string; caption: string };

export type Residence = {
  key: ResidenceKey;
  name: string;
  short: string;
  cover: string;
  intro: string;
  photos: ResidencePhoto[];
};

export const RESIDENCES: Record<ResidenceKey, Residence> = {
  girls: {
    key: "girls",
    name: "Girls’ Residence",
    short: "Girls’ hostel",
    cover: "https://cdn.magicpatterns.com/uploads/3umRPHAHHJXT5NzoZjF5Dy/girls6.jpg",
    intro: "A calm, supervised home for MCC’s female boarders, with shared rooms, study space and the community that makes it feel like home.",
    photos: [
      { src: "https://cdn.magicpatterns.com/uploads/iB1SbzpbhFHDcDnU2CUdCs/girls2.jpg", alt: "Boarders chatting in a shared bunk room in the girls’ residence", caption: "Downtime in the dorm" },
      { src: "https://cdn.magicpatterns.com/uploads/jdwqDNW5nwe2ZdFoBzNbvN/girls5.jpg", alt: "Two made-up bunk beds in the girls’ residence", caption: "A shared bunk room" },
      { src: "https://cdn.magicpatterns.com/uploads/2MMevK9f3FzNtLWpm3W5Ai/girls4.jpg", alt: "Common lounge with sofas and a wall-mounted TV", caption: "The common lounge" },
      { src: "https://cdn.magicpatterns.com/uploads/nj1CPM5RCJU45FuCrK8Tnn/girls3.jpg", alt: "Bunk room with a study desk by the window", caption: "Room with a study desk" },
      { src: "https://cdn.magicpatterns.com/uploads/cbTfTMCx19hd6zjgGiuSpJ/girls1.jpg", alt: "Smaller room with a metal bunk and a pink bunk bed", caption: "A twin bunk room" },
    ],
  },
  boys: {
    key: "boys",
    name: "Boys’ Residence",
    short: "Boys’ hostel",
    cover: "https://cdn.magicpatterns.com/uploads/34AbGWNuNidFTc9henXamK/boys5.jpg",
    intro: "A structured, supervised home for MCC’s male boarders, built around rest, study and friendships that last beyond graduation.",
    photos: [
      { src: "https://cdn.magicpatterns.com/uploads/sNvxGv4Ge7b2ehLxioLCgF/boys4.jpg", alt: "Common lounge with sofas and a brick feature wall", caption: "The common lounge" },
      { src: "https://cdn.magicpatterns.com/uploads/aFBAaExHBgcmDFF81rqUdh/boys3.jpg", alt: "Study and dining area with a table, desks and a printer", caption: "Study and dining room" },
      { src: "https://cdn.magicpatterns.com/uploads/tWk9Mz5RGGFa76b4MVaF1N/boys1.jpg", alt: "Shared room with two bunk beds", caption: "A shared bunk room" },
      { src: "https://cdn.magicpatterns.com/uploads/iGj8mr76rqY9c4keBdNhPm/boys2.jpg", alt: "Bedroom with full-height wardrobes", caption: "Built-in wardrobes" },
    ],
  },
};
